export const BASE_URL = 'http://backend.khoj.info/'
export const API_URL = BASE_URL + 'api/'

export const LOCATION_API_URL= 'https://backend.anthill.club/api/locations/'

export const CONSUMERS = API_URL + 'consumers/'

export const CATEGORIES = API_URL + 'categories/'
export const SUB_CATEGORY = API_URL + "subcategories/"
export const FEATURED_CATEGORY = API_URL + 'featuredcategories/'

export const ORGANIZATIONS = API_URL + 'organizations/'
export const WISHLISTS = API_URL + 'wishlists/'

export const ORGANIZATION_PHONES = API_URL + 'organizationPhones/'
export const ORGANIZATION_EMAILS = API_URL + 'organizationEmails/'
export const ORGANIZATION_LINKS = API_URL + 'organizationLinks/'

export const SUBCATEGORY_SECTIONS = API_URL + 'subcategorySections/'

export const SUBCATEGORY_NDI_CARDS = API_URL + 'subcatNDICards/'
export const SUBCATEGORY_NI_CARDS = API_URL + 'subcatNICards/'
export const SUBCATEGORY_STAT_CARDS = API_URL + 'subcatStatCards/'

export const ORGANIZATION_STAT_CARDS = API_URL + 'orgstatcards/'
export const ORGANIZATION_NDI_CARDS = API_URL + 'orgNDIcards/'
export const ORGANIZATION_NI_CARDS = API_URL + 'orgNIcards/'

export const DIVISIONS = LOCATION_API_URL + 'divisions/'
export const DISTRICTS = LOCATION_API_URL + 'districts/'
export const AREAS = LOCATION_API_URL + 'areas/'

export const SOCIAL_LINKS_API = API_URL + 'sociallinks/'
export const SLIDER = API_URL + 'sliders/'
export const PARTNERS = API_URL + 'homepartners/'
export const COUNTER = API_URL + 'homecounters/'
export const BRANCHES = API_URL + 'branches/'